import { JsonProperty } from 'json-typescript-mapper';
import {Type} from 'class-transformer';

export enum PaymentMethodLabel {
  cash = <any>'Bar',
  creditcard = <any>'Kartenzahlung'
}

export enum PaymentMethodValue {
  cash = <any>'cash',
  creditcard = <any>'creditcard',
}

export class PaymentMethod {
  value: PaymentMethodValue;
  label: PaymentMethodLabel;
}

export enum SocialMediaLabel {
  instagram = <any>'Instagram',
  twitter = <any>'Twitter',
  facebook = <any>'Facebook'
}
export enum SocialMediaValue {
  instagram = <any>'instagram',
  twitter = <any>'twitter',
  facebook = <any>'facebook'
}
export class SocialMediaName {
  label: SocialMediaLabel;
  value: SocialMediaValue;

  constructor(initNull?: boolean) {
    for (const key of Object.keys(this)) {
      this[key] = null;
    }
  }
}
export class SocialMedia {
  link: string;
  name: SocialMediaName;
  type: string;

  constructor(initNull?: boolean) {
    for (const key of Object.keys(this)) {
      this[key] = null;
    }
  }
}

export class Image {
  id: string;
  url: string;
  imageWidth: number;
  imageHeight: number;

  constructor(initNull?: boolean) {
    for (const key of Object.keys(this)) {
      this[key] = null;
    }
  }
}

export class Description {
  headline: string;
  text1: string;
  text2: string;
  imageGallery: Image[];
  type: string;

  constructor(initNull?: boolean) {
    for (const key of Object.keys(this)) {
      this[key] = null;
    }
  }
}

export class MarketWebsiteMerchant {
  @JsonProperty('id')
  public id: number = void 0;
  @JsonProperty('merchantNumber')
  public merchantNumber: string = void 0;
  @JsonProperty('marketmanagerOriginalId')
  public marketmanagerOriginalId: string = void 0;
  @JsonProperty('termsOfUse')
  public termsOfUse: boolean = void 0;
  @JsonProperty('company')
  public company: string = void 0;
  @JsonProperty('companyAdditional')
  public companyAdditional: string = void 0;
  @JsonProperty('street')
  public street: string = void 0;
  @JsonProperty('zipcode')
  public zipcode: string = void 0;
  @JsonProperty('city')
  public city: string = void 0;
  @JsonProperty('suburb')
  public suburb: string = void 0;
  @JsonProperty('state')
  public state: string = void 0;
  @JsonProperty('country')
  public country: string = void 0;
  @JsonProperty('phone')
  public phone: string = void 0;
  @JsonProperty('phoneAdditional')
  public phoneAdditional: string = void 0;
  @JsonProperty('fax')
  public fax: string = void 0;
  @JsonProperty('mobile')
  public mobile: string = void 0;
  @JsonProperty('email')
  public email: string = void 0;
  @JsonProperty('emailAdditional')
  public emailAdditional: string = void 0;
  @JsonProperty('web')
  public web: string = void 0;
  @JsonProperty('selfProducer')
  public selfProducer: boolean = void 0;
  @JsonProperty('organic')
  public organic: boolean = void 0;
  @JsonProperty('vegan')
  public vegan: boolean = void 0;
  @JsonProperty('status')
  public status: string = void 0;
  @JsonProperty('socialMedia')
  public socialMedia: SocialMedia[] = [];
  @JsonProperty('paymentMethods') @Type(() => PaymentMethod)
  public paymentMethods: PaymentMethod[] = [];
  @JsonProperty('description') @Type(() => Description)
  public description: Description[] = void 0;
  @JsonProperty('image') @Type(() => Image)
  public image: Image = void 0;
  @JsonProperty('representative')
  public representative: string = void 0;
  @JsonProperty('pendingVersion')
  public pendingVersion: number = void 0;
  @JsonProperty('publishedVersion')
  public publishedVersion: number = void 0;
  @JsonProperty('version')
  public version: string = void 0;
  @JsonProperty('updated')
  public updated: string = void 0;
  @JsonProperty('updatedBy')
  public updatedBy: string = void 0;
  @JsonProperty('responsibleAccordingToTMG')
  public responsibleAccordingToTMG?: boolean = void 0;
  @JsonProperty('noWebsiteParticipation')
  public noWebsiteParticipation?: boolean = void 0;
  @JsonProperty('advancedMarketwebsite')
  public advancedMarketwebsite?: boolean = void 0;
  @JsonProperty('marketwebsiteSelfPresentation')
  public marketwebsiteSelfPresentation?: boolean = void 0;
  @JsonProperty('marketwebsiteAdvertisingPresentation')
  public marketwebsiteAdvertisingPresentation?: boolean = void 0;
  @JsonProperty('marketwebsiteAdvertisingPresentationFirstActivation')
  marketwebsiteAdvertisingPresentationFirstActivation?: string = void 0;
  @JsonProperty('regionalGoods')
  regionalGoods?: boolean = void 0;
  @JsonProperty('postalInvoice')
  public postalInvoice: boolean = void 0;

  constructor(initNull?: boolean) {
    for (const key of Object.keys(this)) {
      this[key] = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/market-website-merchant.model.ts